import styled, {css} from "styled-components"
import Flex, {FlexProps} from "@irati/ui/src/Flex"
import {Body} from "@irati/ui/src/Typography"
import {spacingCss, SpacingProps} from "../../global/css"

export const Container = styled(Flex)<BannerProps>`
  ${({theme, image}) => css`
    background: linear-gradient(${theme.colors.secondary2}, ${theme.colors.primary2});
    ${image && `
      background: url("${image}");
    `}
    background-repeat: no-repeat;
    background-position: center;
    background-size: cover;
    border-radius: ${theme.border.radius.large};
    height: 350px;
    ${Body} {
      color: ${theme.colors.utility.white};
    }
    ${spacingCss}
  `}
`

interface BannerProps extends SpacingProps, FlexProps {
  image?: string
}

export const Content = styled(Flex)`
  ${({theme}) => css`
    width: 100%;
    padding: 0 ${theme.spacing.two};
    ${theme.mediaQueries.minWidthMedia.desktop`
      width: 75%;
      padding: 0 ${theme.spacing.six};
    `}
  `}
`
